'use strict';

// フィルター（絞り込み・並び替えのセレクト。HAML は shared/_filter_bar、見た目は components/_filter_bar.scss）
// 選んだらその場でフォームを送信する。document に委譲するので Turbolinks の画面遷移後も再登録は要らない
$(document).on('change', '.js-filter-bar-select', function () {
  this.form.submit();
});
